import React from 'react';
import type { ActionSummary, RowAction } from '../types';

interface CountChipProps {
  label: string;
  value: number;
  colorCls: string;
}

const CountChip: React.FC<CountChipProps> = ({ label, value, colorCls }) => (
  <div className={`flex flex-col items-center px-4 py-3 rounded-lg border ${colorCls} min-w-[80px]`}>
    <span className="text-2xl font-bold leading-none">{value}</span>
    <span className="text-xs font-semibold uppercase tracking-wide mt-1 opacity-80">{label}</span>
  </div>
);

const CHIPS: { action: RowAction; label: string; colorCls: string }[] = [
  { action: 'CREATE',    label: 'Create',    colorCls: 'border-emerald-200 dark:border-emerald-700 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-800 dark:text-emerald-300' },
  { action: 'UPDATE',    label: 'Update',    colorCls: 'border-blue-200 dark:border-blue-700 bg-blue-50 dark:bg-blue-900/20 text-blue-800 dark:text-blue-300' },
  { action: 'LINK',      label: 'Link',      colorCls: 'border-indigo-200 dark:border-indigo-700 bg-indigo-50 dark:bg-indigo-900/20 text-indigo-800 dark:text-indigo-300' },
  { action: 'AMBIGUOUS', label: 'Ambiguous', colorCls: 'border-amber-200 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300' },
  { action: 'ERROR',     label: 'Error',     colorCls: 'border-red-200 dark:border-red-700 bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-300' },
  { action: 'SKIPPED',   label: 'Skipped',   colorCls: 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-400' },
];

interface PreviewSummaryStripProps {
  summary: ActionSummary;
}

const PreviewSummaryStrip: React.FC<PreviewSummaryStripProps> = ({ summary }) => (
  <div className="flex flex-wrap gap-3">
    {CHIPS.map(({ action, label, colorCls }) => (
      <CountChip key={action} label={label} value={summary[action] ?? 0} colorCls={colorCls} />
    ))}
  </div>
);

export default PreviewSummaryStrip;
